import styled from 'styled-components'
import Typography, { FontWeights } from 'builder/styles/typography'
import Colors from 'builder/styles/colors'
import { Tip } from './elements/Tip'

export const Container = styled.div`
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.color};
  display: flex;
  width: 100%;
  height: 332px;
  max-width: 744px;
  border-radius: 12px;
  position: relative;
`

export const TipIcon = styled(Tip)<{ $tipPosition: number; $tipBackgroundColor?: string }>`
  position: absolute;
  left: -13px;
  color: ${({ theme, $tipBackgroundColor }) => $tipBackgroundColor || theme.background};
  top: ${({ $tipPosition }) => $tipPosition}px;
`

export const WidgetContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
`

export const WidgetBox = styled.div`
  flex: 1;
`

export const WidgetImage = styled.img`
  max-width: 100%;
  height: auto;
  object-fit: contain;
`

export const ActionButton = styled.button`
  background: ${Colors.White};
  color: ${Colors.Neutral90};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  ${Typography.Body}
  ${FontWeights.Regular}
  border: 1px solid ${Colors.Neutral15};
  border-radius: 8px;
  cursor: pointer;
`
